import { getScoreStatus } from './scoreUtils';

/**
 * Client-side audit field scoring (same rules as saving an audit in AuditTemplateContent).
 * Used when persisting form_score / form_max_score and when building section score cards.
 *
 * @param {Array<Record<string, unknown>>} fields
 * @returns {{ totalScore: number, totalMaxPossible: number }}
 */
export function calculateScoreForFields(fields) {
    if (!Array.isArray(fields)) {
        return { totalScore: 0, totalMaxPossible: 0 };
    }

    let totalScore = 0;
    let totalMaxPossible = 0;

    fields.forEach((field) => {
        const { value, scoring_rules, max_score, timer, threshold, params } =
            field;

        if (!max_score) return;

        const values = Array.isArray(value) ? value : [value];

        const isNA = values.some((v) => {
            const opt = params?.options?.find((o) => o.value === v);
            return opt?.isNA === true;
        });

        if (isNA) return;

        totalMaxPossible += Number(max_score);

        if (!Array.isArray(scoring_rules) || scoring_rules.length === 0) return;

        const rules = [...scoring_rules];
        const isCorrect = values.some((v) => rules.includes(v));

        if (!isCorrect) return;

        const maxScore = Number(max_score ?? 0);

        if (threshold) {
            const thresholdNum = Number(threshold);
            if (thresholdNum > 0) {
                const halfScore = maxScore / 2;
                const timerValue = Number(timer ?? 0);
                const timePercentage = Math.min(timerValue / thresholdNum, 1);
                const timerScore = timePercentage * halfScore;

                totalScore += halfScore + timerScore;
            } else {
                totalScore += maxScore;
            }
        } else {
            totalScore += maxScore;
        }
    });

    return {
        totalScore: Math.round(totalScore * 100) / 100,
        totalMaxPossible,
    };
}

/**
 * WidgetCard preset from section percentage (0–100).
 * @param {number} percent
 * @returns {'success' | 'warning' | 'danger'}
 */
export function presetForSectionPercent(percent) {
    const p = Number(percent);
    if (!Number.isFinite(p)) return 'danger';
    const status = getScoreStatus(p);
    return status === 'neutral' ? 'info' : status;
}
